import * as Sentry from '@sentry/react';
import {
  getReleaseTag,
  getSentryDsn,
  getSentryEnvironment,
} from '@utils/environment';
import * as React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import { SENTRY_IGNORE_LIST } from './sentry-ignore-list';

Sentry.init({
  dsn: getSentryDsn(),
  release: getReleaseTag(),
  environment: getSentryEnvironment(),
  ignoreErrors: SENTRY_IGNORE_LIST,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  // 1% of the transactions are sampled for performance monitoring
  tracesSampleRate: 0.01,
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/api.assessment.alignerr\.com/,
    /^https:\/\/api.interview.alignerr\.com/,
  ],
  beforeSend(event: Sentry.ErrorEvent) {
    // Only send events tagged by the ErrorBoundary (page crashes)
    // or explicitly captured with manualCapture (eg persona issues or after auth actions)
    // All other low-level errors are dropped to reduce Sentry costs.
    const hasTag = (tag: unknown): boolean => tag === true || tag === 'true';
    if (
      hasTag(event.tags?.errorBoundary) ||
      hasTag(event.tags?.manualCapture)
    ) {
      return event;
    }

    return null;
  },
});
